import * as React from 'react';

import { IconComponent, IconSize } from 'shared/entities/components/Icon';
import { TranslationString } from 'shared/entities/localization';
import { ReferenceProps } from 'shared/newEntities/components/Reference';

import { TypographyColor } from '../Typography';
import { WithMetaProps } from '../WithMeta';

export enum InputSize {
  xxs = 'xxs',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export type InputProps = WithMetaProps &
  Omit<
    React.HTMLProps<HTMLInputElement>,
    'onChange' | 'value' | 'label' | 'placeholder' | 'size'
  > & {
    value: string;
    placeholder?: TranslationString | string;
    onChange?: (
      value: string,
      originalEvent: React.ChangeEvent<HTMLInputElement>
    ) => void;
    size?: InputSize;
    reference?: Omit<ReferenceProps, 'trigger'>;
    withCopying?: boolean;
    endOfLine?: TranslationString | string;
    Icon?: IconComponent;
    prefix?: string;
    prefixFontColor?: TypographyColor;
    withoutPrefixBorder?: boolean;
    inputStyle?: Record<string, string>;
    fontSize?: 'xs' | 's' | 'm';
    currency?: '₽' | '$';
    withoutBorder?: boolean;
    forceFocus?: boolean;
    right?: React.ReactNode;
    onClear?: () => void;
    labelReference?: ReferenceProps;
    withTimeoutOnBlur?: boolean;
    iconSize?: IconSize;
    withoutErrorIcon?: boolean;
  };
